<div class="applicant-review-summary-card" aria-label="Applicant Review Summary">
  <header class="summary-card-header">
    <div class="summary-step-count">3</div>
    <h3 class="summary-title">Applicant Review Summary <span class="summary-progress">{{ reviewedProgressText()
        }}</span></h3>
  </header>

  <div class="summary-primary-applicant">
    <p class="summary-label">Primary Applicant:</p>
    <div class="primary-applicant-chip">
      <mat-icon class="primary-applicant-icon">account_circle</mat-icon>
      <app-tooltip [text]="applicantName()" [position]="'above'" class="primary-applicant-tooltip"
        [disabled]="!isTextOverflowing(applicantNameElement)">
        <span #applicantNameElement class="primary-applicant-name">{{ applicantName() }}</span>
      </app-tooltip>
    </div>
  </div>

  <div class="summary-status-list">
    @for (status of statusBanners(); track status.message) {
    <app-banner class="summary-status-banner" [class.summary-status-banner--fit]="status.variant === 'warning'"
      [class.summary-status-banner--full]="status.variant !== 'warning'" [variant]="status.variant"
      [message]="status.message" [iconName]="status.iconName"></app-banner>
    }
  </div>

  @if (!isReadOnly() && !isCurrentApplicantReviewed()) {
  <app-tooltip class="summary-action-tooltip"
    [text]="canMarkApplicantReviewed() ? 'Review Complete! Click here to finalize their status.' : 'Complete Applicant Profile, MAF, and Documents to enable this action.'"
    [position]="'above'">
    <app-buttons class="summary-action-button" [variant]="'primary'" [label]="'Mark Applicant as Reviewed'"
      [disabled]="!canMarkApplicantReviewed()" (clicked)="onMarkReviewedClick()">
      <mat-icon btn-icon-start>check_box</mat-icon>
    </app-buttons>
  </app-tooltip>
  } @else if (!isReadOnly()) {
  <div class="summary-complete-strip">
    <div class="summary-complete-label">
      <mat-icon>check</mat-icon>
      <span>Applicant Review Complete</span>
    </div>
    <button type="button" class="summary-reopen-btn" (click)="onMarkReviewedClick()">Reopen</button>
  </div>

  <app-buttons class="summary-action-button" [variant]="'primary'" [label]="'Proceed to next Applicant'"
    [disabled]="!canProceedNextApplicant()" (clicked)="onProceedNextApplicantClick()">
    <mat-icon btn-icon-end>chevron_right</mat-icon>
  </app-buttons>
  }
</div>